import { ProductKeys, ProductKeys3P } from '../constants/product-keys';
import { type ThirdPartyConfigsBootstrap } from '../constants/schemas/3p-config';

/**
 * Determines whether GitHub PR hydration should run for Full Page Search
 * Jira issue results.
 *
 * Prerequisites:
 * 1. The user must have Jira enabled (available in their product suite).
 *    Linked PRs are only relevant on Jira issue results.
 * 2. The user must have the GitHub connector authenticated (not requiring OAuth).
 *    Users without GitHub connected can never see linked PRs.
 *
 * @param thirdPartyConfigs - Bootstrap third-party connector config
 * @param availableProducts - List of products available to the user
 * @returns boolean - Whether to fetch and display linked GitHub PRs
 */
export const shouldHydrateJiraGitHubPRs = (
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
	availableProducts: readonly ProductKeys[],
): boolean => {
	// Prerequisite: user must have Jira enabled
	if (!availableProducts.includes(ProductKeys.Jira)) {
		return false;
	}

	// Prerequisite: user must have GitHub connector authenticated
	if (thirdPartyConfigs[ProductKeys3P.Github]?.userNeedsOAuth !== false) {
		return false;
	}

	return true;
};
